import { ValueTimeResponse } from "../api/value-time.response";

export class ValueTime {
    value: number = 0;
    time?: Date;
    status?: string;
    isFilled?: boolean;

    constructor(json?: ValueTimeResponse) {
        if (!json) return;
        this.initializeFromJson(json);
    }
    initializeFromJson(json: ValueTimeResponse) {
        if (json?.value !== undefined && json.value !== null) this.value = json.value;
        if (json?.time) this.time = new Date(json.time);
        if (json?.status) this.status = json.status;
        if (json?.isFilled) this.isFilled = json.isFilled;
    }
}